import React, { Component } from 'react';
import { Button } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as ServerUtils from '../ServerUtils/ServerUtils'

class JerseyQuality extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    setPremium = () => {
        this.setJerseyQuality('premium');
    }

    setStandard = () => {
        this.setJerseyQuality('standard');
    }

    setJerseyQuality = (type) => {
        console.log("++++++++++:setJerseyQuality");
        //  console.log("this.props.order.key:" + this.props.order.key);
        // console.log("this.props.user.email:" + this.props.user.email);

        let orderUpdates = '';

        orderUpdates = {
            jerseyQuality: type,
            jerseyQualityBy: this.props.user.email
        }

        //UPDATE INDY ORDER
        FbUtils.updateIndividualOrder(this.props.mainOrder.key, this.props.orderId, orderUpdates);

        //UPDATE MAIN ORDER
        FbUtils.updateOrder(this.props.mainOrder.key, orderUpdates);

        // this.sendUpdateToApi(type);
        //  udpateIndyOrderDetails(indyOrderKey, mainOrderKey, itemToUpdate, valueToUpdate, userEmail)
        ServerUtils.udpateIndyOrderDetails(this.props.orderId, this.props.mainOrder.key, 'jerseyQuality', type, this.props.user.email);
    }




    render() {

        const standardButton = this.props.order.jerseyQuality && this.props.order.jerseyQuality === 'standard'
            ? <Button type='Button' onClick={this.setPremium} type='button' color='yellow' fluid size='small'> $$ MAKE PREMIUM $$ </Button>
            : ''

        const premiumButton = this.props.order.jerseyQuality && this.props.order.jerseyQuality === 'premium'
            ? <Button type='Button' onClick={this.setStandard} type='button' color='purple' fluid size='small'>MAKE STANDARD</Button>
            : ''


        return (
            <div>
                {standardButton}
                {premiumButton}
            </div>
        );
    }
}

export default JerseyQuality;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/FootBallQuality/JerseyQuality.js